import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import password_icon from "../../../Assets/svg/password_icon.svg";
import hide_eye_icon from "../../../Assets/svg/hide_eye_icon.svg";
import show_eye_icon from "../../../Assets/svg/show_eye_icon.svg";
import { post } from "helpers/api_helper";
import toast from "react-hot-toast";
import { resetPasswordSchema } from "helpers/yup_validator";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email, otp } = location.state || {};
  
  const [pass, setPass] = useState(false);
  const [cnfPass, setCnfPass] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: async (values) => {
      try {
        const response = await post("/user/reset/password", {
          otp,
          email: email,
          newPassword: values.password,
        });
        if (response?.success) {
          toast.success(response.message);
          navigate("/login");
        }
      } catch (error) {
        console.error("Error resetting password:", error?.message);
      }
    },
  });

  const handlePasswordTogglePass1 = () => {
    setPass(!pass);
  };

  const handlePasswordTogglePass2 = () => {
    setCnfPass(!cnfPass);
  };

  return (
    <>
      <div className="formInner">
        <div className="top py-2 text-center">
          <h2 className="m-0 fw-sbold head">Reset Password!</h2>
          <p className="m-0 py-1">Please enter your new password</p>
        </div>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col lg="12" className="my-3">
              <div className="FormHeading">
                <h4 className="m-0 fw-sbold themeClr">Set New Password</h4>
                <p className="m-0">Please enter your new password below.</p>
              </div>
            </Col>
            <Col lg="12" className="my-3">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <input
                    type={pass ? "text" : "password"}
                    className="form-control"
                    placeholder="********"
                    {...formik.getFieldProps("password")}
                  />
                  <span
                    className="icn position-absolute"
                    style={{ left: "8px" }}
                  >
                    <img src={password_icon} alt="" />
                  </span>
                  <Button
                    onClick={handlePasswordTogglePass1}
                    variant="transparent"
                    className="border-0 p-0 icn position-absolute"
                    style={{ right: "8px" }}
                  >
                    {pass ? (
                      <img src={show_eye_icon} alt="" />
                    ) : (
                      <img src={hide_eye_icon} alt="" />
                    )}
                  </Button>
                </div>
                <label className="form-label position-absolute d-inline-block bg-white m-0 px-1">
                  Password
                </label>
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-danger">{formik.errors.password}</div>
                ) : null}
              </div>
            </Col>
            <Col lg="12" className="my-3">
              <div className="position-relative labelInput">
                <div className="iconWithText position-relative">
                  <input
                    type={cnfPass ? "text" : "password"}
                    className="form-control"
                    placeholder="********"
                    {...formik.getFieldProps("confirmPassword")}
                  />
                  <span
                    className="icn position-absolute"
                    style={{ left: "8px" }}
                  >
                    <img src={password_icon} alt="" />
                  </span>
                  <Button
                    onClick={handlePasswordTogglePass2}
                    variant="transparent"
                    className="border-0 p-0 icn position-absolute"
                    style={{ right: "8px" }}
                  >
                    {cnfPass ? (
                      <img src={show_eye_icon} alt="" />
                    ) : (
                      <img src={hide_eye_icon} alt="" />
                    )}
                  </Button>
                </div>
                <label className="form-label position-absolute d-inline-block bg-white m-0 px-1">
                  Confirm Password
                </label>
                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                  <div className="text-danger">{formik.errors.confirmPassword}</div>
                ) : null}
              </div>
            </Col>
            <Col lg="12" className="my-3">
              <Button
                type="submit"
                className="d-flex align-items-center justify-content-center w-100 commonBtn"
              >
                Reset Password
              </Button>
              <div className="text-center mt-3">
                <p className="m-0 fw-sbold">
                  Remembered your password?{" "}
                  <Link className="themeClr" to={"/login"}>
                    Log In
                  </Link>
                </p>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default ResetPassword;
